import { createSlice } from '@reduxjs/toolkit'

export const CampaignCountDisplayStatus = createSlice({
  name: 'campaign_status_display',
  initialState: {
    value : []
  },
  reducers: {
    campaignCountFilter: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { campaignCountFilter } = CampaignCountDisplayStatus.actions

export default CampaignCountDisplayStatus.reducer